import React from 'react';
import { observer } from 'mobx-react';
import { Col, Grid } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import cx from 'classnames';

@observer
export default class TrendsPostsList extends React.Component {
    render() {
        const { loadMorePosts, store } = this.props;
        const { postsPaged, posts } = store;
        const hideShowMore = postsPaged.length >= posts.length;

        return (
            <Col xs={12} componentClass="section" className="post-list">
                <Grid>
                    <h2>View more articles below.</h2>
                    {store.postsPaged.length
                        ? store.postsPaged.map((post, i) => {
                              let linkHref = `/trend/${post.blogPostUrlPath}`;

                              return (
                                  <Link to={linkHref} key={i}>
                                      <Col
                                          xs={12}
                                          className={cx('post', {
                                              grey: i % 2 === 0
                                          })}
                                      >
                                          <h3>{post.title}</h3>
                                          <p>{post.summary}</p>
                                      </Col>
                                  </Link>
                              );
                          })
                        : null}
                    {hideShowMore ? null : (
                        <Col xs={12}>
                            <button
                                className="compass-btn"
                                onClick={() => {
                                    loadMorePosts();
                                }}
                            >
                                Show more
                            </button>
                        </Col>
                    )}
                </Grid>
            </Col>
        );
    }
}



// WEBPACK FOOTER //
// ./src/common/components/trends/TrendsPostsList.jsx